/**
 * Aggregate quality scores (`beforeScore`/`afterScore`/`lift`/`catalogContentQualityScore`/
 * `qualityScore.score`) now arrive over the wire on a 0–10 scale, but every UI surface
 * (progress bars, gauges, "/100" labels) still presents them out of 100. Scaling happens
 * once here, at each query hook's `select`, so no render site has to know about the wire scale.
 */
export function scaleScore<T extends number | null | undefined>(value: T): T {
  return (value == null ? value : value * 10) as T;
}
